import React from "react";
import semanticVariables from "ui-v2/styles/semantic_colors.module.scss";

export default ({ width = 24, height = 24, color = "primary" }) => {
  const colorValue = semanticVariables?.[`semantic_icon_${color}`];
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.9999 1.75C11.0811 1.75 10.1999 2.11499 9.55024 2.76467C8.90056 3.41435 8.53557 4.2955 8.53557 5.21429V12.6786C8.53557 13.5974 8.90056 14.4785 9.55024 15.1282C10.1999 15.7779 11.0811 16.1429 11.9999 16.1429C12.9186 16.1429 13.7998 15.7779 14.4495 15.1282C15.0992 14.4785 15.4641 13.5974 15.4641 12.6786V5.21429C15.4641 4.2955 15.0992 3.41435 14.4495 2.76467C13.7998 2.11499 12.9186 1.75 11.9999 1.75Z"
        fill={colorValue}
      />
      <path
        d="M7.32129 11.3214C7.32129 10.9072 6.9855 10.5714 6.57129 10.5714C6.15708 10.5714 5.82129 10.9072 5.82129 11.3214V12.6786C5.82129 14.3172 6.47224 15.8888 7.63095 17.0475C8.61146 18.028 9.8876 18.6449 11.2499 18.8115V20.75H8.607C8.19279 20.75 7.857 21.0858 7.857 21.5C7.857 21.9142 8.19279 22.25 8.607 22.25H15.3927C15.8069 22.25 16.1427 21.9142 16.1427 21.5C16.1427 21.0858 15.8069 20.75 15.3927 20.75H12.7499V18.8115C14.1121 18.6449 15.3883 18.028 16.3688 17.0475C17.5275 15.8888 18.1784 14.3172 18.1784 12.6786V11.3214C18.1784 10.9072 17.8426 10.5714 17.4284 10.5714C17.0142 10.5714 16.6784 10.9072 16.6784 11.3214V12.6786C16.6784 13.9194 16.1855 15.1094 15.3081 15.9868C14.4307 16.8642 13.2407 17.3571 11.9999 17.3571C10.759 17.3571 9.56901 16.8642 8.69161 15.9868C7.81421 15.1094 7.32129 13.9194 7.32129 12.6786V11.3214Z"
        fill={colorValue}
      />
    </svg>
  );
};
